var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    d: "M20.841 3.065a.246.246 0 0 0-.016.089v9.354a.246.246 0 1 0 .492 0V3.74h1.33v9.915a2.051 2.051 0 0 1-2.052 2.052H3.035a2.051 2.051 0 0 1-2.05-2.052V2.99c0-1.133.918-2.052 2.05-2.052H18.79c1.133 0 2.051.919 2.051 2.052v.075zM3.979 7.338c-.566 0-1.025.46-1.025 1.026v2.872c0 .566.459 1.026 1.025 1.026h3.857c.566 0 1.026-.46 1.026-1.026V8.364c0-.566-.46-1.026-1.026-1.026H3.979zm-.533-2.953a.492.492 0 0 0 0 .984h14.77a.492.492 0 0 0 0-.984H3.445zm7.877 2.953a.492.492 0 0 0 0 .985h5.908a.492.492 0 1 0 0-.985h-5.908zm0 2.954a.492.492 0 0 0 0 .985h2.954a.492.492 0 0 0 0-.985h-2.954z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNews);
export default __webpack_public_path__ + "static/media/ic-news.07c400d949208cf54259c6f9df355945.svg";
export { ForwardRef as ReactComponent };